// 单文件引入方式

import Selector from './ZuiSelector.vue'

export default {
  install(Vue) {
    Vue.component('ZuiSelector', Selector)
  }
}

export { Selector }
